import { useTranslation } from 'react-i18next';
import { ColorSwatchSelector } from '@components/floorplan-v2/color-swatch-selector';
import { ImageGalleryField } from '@components/image-gallery-field';
import { SectionDisclosure } from '@components/section-disclosure';
import classNames from 'classnames';

import { AppearanceSectionProps } from './appearance-section.type';
import { APPEARANCE_COLOR_PICKER_Z_INDEX, DEFAULT_APPEARANCE_PALETTE } from './constants';

export const APPEARANCE_SECTION_TEST_ID = 'appearance-section';

const FIELD_LABEL_CLASS = 'mb-2 block text-secondary text-subtitle-s';

export const AppearanceSection = ({
  value,
  onChange,
  open,
  onToggleOpen,
  disabled = false,
  galleryController,
  floorplanImageUrl,
  initialColors = DEFAULT_APPEARANCE_PALETTE,
  onColorsChange,
  dataTestId = APPEARANCE_SECTION_TEST_ID,
}: AppearanceSectionProps) => {
  const { t } = useTranslation();

  return (
    <SectionDisclosure
      title={t('offers:appearanceSectionTitle')}
      open={open}
      onToggleOpen={onToggleOpen}
      dataTestId={`${dataTestId}-disclosure`}>
      <section
        data-testid={dataTestId}
        className={classNames('flex flex-col gap-6 w-full py-4 md:py-6', {
          'cursor-not-allowed opacity-50 pointer-events-none': disabled,
        })}>
        <div data-testid={`${dataTestId}-color`}>
          <span className={FIELD_LABEL_CLASS}>{t('floorplanV2:addSeatingColorLabel')}</span>
          <div className='p-4'>
            <ColorSwatchSelector
              value={value.color}
              onChange={(color) => onChange({ color })}
              initialColors={[...initialColors]}
              onColorsChange={onColorsChange}
              floorplanImageUrl={floorplanImageUrl}
              zIndex={APPEARANCE_COLOR_PICKER_Z_INDEX}
              editable
              dataTestId={`${dataTestId}-color`}
            />
          </div>
        </div>

        <div data-testid={`${dataTestId}-images`}>
          <span className={FIELD_LABEL_CLASS}>{t('offers:appearanceSectionImagesLabel')}</span>
          <ImageGalleryField controller={galleryController} namespace='offers' />
        </div>
      </section>
    </SectionDisclosure>
  );
};
